// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mergeConfigs = (stateConfig: any, propsConfig: any) => {
    const { prodcatConfig = {}, ...restOfStateConfig } = stateConfig;
    const { prodcatConfig: prodcatPropsConfigs, ...restOfPropsConfig } = propsConfig;

    return {
        ...prodcatConfig,
        ...prodcatPropsConfigs,
        ...restOfStateConfig,
        ...restOfPropsConfig
    };
};
